import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../store/slices/auth.slice';
import usersReducer from '../slices/usersSlice';

export const useAuthStore = create()(
  devtools(
    persist(
      (set, get) => ({
        user: null,
        token: null,
        isAuthenticated: false,
        
        login: (userData, token) => 
          set({ user: userData, token, isAuthenticated: true }),
        
        logout: () => 
          set({ user: null, token: null, isAuthenticated: false }),
        
        updateUser: (userData) => 
          set({ user: { ...get().user, ...userData } }),
      }),
      { name: 'auth-storage' }
    )
  )
);


const store = configureStore({
  reducer: {
    auth: authReducer,
    users: usersReducer,
    // Add other reducers here
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['users/fetchUsers/fulfilled'],
        ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
        ignoredPaths: ['users.users.createdAt'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;

export const useProductStore = create()(
  devtools((set, get) => ({
    products: [],
    selectedProduct: null,
    filters: {},
    
    setProducts: (products) => set({ products }),
    
    addProduct: (product) => 
      set({ products: [...get().products, product] }),
    
    updateProduct: (id, updates) =>
      set({
        products: get().products.map(p => 
          p.id === id ? { ...p, ...updates } : p
        ),
      }),
    
    deleteProduct: (id) =>
      set({
        products: get().products.filter(p => p.id !== id),
      }),
    
    setSelectedProduct: (product) => set({ selectedProduct: product }),
    
    setFilters: (filters) => set({ filters }),
  }))
);